var app = angular.module('leonardo');

var TemplatesAuditService = function(BaseRestService) {
  var service = new BaseRestService('templates-audit', function(RestangularConfigurer) {
    RestangularConfigurer.addElementTransformer('templates-audit', false, function(change) {
      change.addRestangularMethod('accept', 'post', 'accept');
      change.addRestangularMethod('reject', 'post', 'reject');
      return change;
    });
  });

  service.STATUS_PENDING = '0';
  service.STATUS_ACCEPTED = '1';
  service.STATUS_REJECTED = '2';
  service.STATUS_NOTACCEPTED = '4';

  service.STATUS_OPTIONS = [
    {
      id: service.STATUS_PENDING,
      name: 'Pending'
    },
    {
      id: service.STATUS_ACCEPTED,
      name: 'Accepted'
    },
    {
      id: service.STATUS_REJECTED,
      name: 'Rejected'
    }
  ];

  return service;
};

app.factory('TemplatesAuditService', ['BaseRestService', TemplatesAuditService]);
